import { captureException, init, setTag } from "@sentry/browser";

const graphqlErrorContexts = new WeakMap<
  object,
  { operation_name: string; variables: unknown }
>();

export function setClientGraphqlSentryContext(
  error: unknown,
  operationName: string,
  variables: unknown
) {
  if (typeof error !== "object" || error === null) {
    return;
  }

  let sanitizedVariables: unknown;

  try {
    sanitizedVariables = JSON.parse(
      JSON.stringify(variables ?? {}, (key, value) => {
        if (/^(select|prismaSelect)$/i.test(key)) {
          return undefined;
        }

        if (/password|token|secret|authorization|api[_-]?key/i.test(key)) {
          return "[Filtered]";
        }

        return value;
      })
    );
  } catch {
    sanitizedVariables = "[Unavailable]";
  }

  graphqlErrorContexts.set(error, {
    operation_name: operationName,
    variables: sanitizedVariables,
  });
}

if (process.env.NEXT_PUBLIC_SENTRY_DSN) {
  init({
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
    environment: process.env.NEXT_PUBLIC_STAGE,
    beforeSend(event, hint) {
      const error = hint.originalException;
      const graphql =
        typeof error === "object" && error !== null
          ? graphqlErrorContexts.get(error)
          : undefined;

      if (graphql) {
        event.contexts = { ...event.contexts, graphql };
      }

      return event;
    },
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "Failed to fetch dynamically imported module",
      "Importing a module script failed",
      "Transition was aborted because of invalid state",
      "Unauthorized",
      "Failed to load Stripe.js",
      "View transition was skipped because document visibility state is hidden.",
    ],
  });
}

export default { captureException, setTag };
